import React, { useEffect, useState } from "react";
import {
    getCoinHistoryAPI,
    getDataReportAPI,
    getUserActivityAPI,
    getUsersByTypeAPI,
} from "../service/AuthService";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import toast from "react-hot-toast";
import { useToast } from "@chakra-ui/react";


export default function DataReports() {
    const [selectedUserName, setSelectedUserName] = useState(20);
    const [userType, setUserType] = useState("CLIENT");
    const REPORT_ENUM = [
        "ALL",
        "NAME",
        "CONTACT",
        "LIMIT",
        "MATCH_COMMISSION",
        "SESSION_COMMISSION",
        "SHARE",
        "CASINO_SHARE",
        "MATKA_SHARE",
        "MATKA_COMMISSION",
        "CASINO_COMMISSION",
        "STATUS",
    ];
    const [payload, setPayload] = useState({
        dataReportType: "ALL",
        endTime: moment().toISOString(),
        page: 0,
        size: 1000,
        startTime: moment()
            .subtract("d", 7)
            .toISOString(),
        toFetchFor: 0,
        userType: "",
    });
    const [data, setData] = useState([]);
    const [opningData, setOpningBalance] = useState([]);
    const location = useLocation();
    const params = useParams();

    const toast = useToast();


    const [fromDate, setFromDate] = useState(
        moment().subtract(7, "d").format("YYYY-MM-DD")
    );
    const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));


    const [users, setUsers] = useState([]);
    const getUsersByType = async () => {
        const { response, code } = await getUsersByTypeAPI(
            userType?.toLocaleUpperCase()
        );
        if (code === 200) {
            setUsers(response?.users);
        }
    };
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: "black",
        }),
    };
    const getUserActivity = async () => {
        if (payload?.userName) {
            toast.error("Please Select User")
            return
        }
        const { response, code } = await getDataReportAPI({
            ...payload,
            userType: undefined,
        });
        if (code == 200) {
            setData(response?.dataReport?.content);
        }
    };

    const handleSubmit = async () => {
        if (payload?.activityLogType === "LOGIN") {
            getUserActivity();
        }
    };

    const getAccountStatement = async () => {
        try {
            const startDate = moment().subtract(1, "year").valueOf();
            const endDate = moment().valueOf(); const { response, code } = await getCoinHistoryAPI(
                payload?.toFetchFor,
                startDate,
                endDate
            );
            if (code === 200) {
                const filteredData = response?.coinHistory?.filter(
                    (item) => item?.id && item?.description?.startsWith("Opening")
                );
                setOpningBalance(filteredData)
            } else {
                throw response;
            }
        } catch (err) {
            toast({
                title: "Error",
                description: err || "Failed to load statement",
                status: "error",
                duration: 9000,
                isClosable: true,
            });
        }
    };

    useEffect(() => {
        getUsersByType();
    }, [userType]);


    return (
        <div className="content-wrapper" style={{ minHeight: "1448.29px" }}>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">Data Reports</div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="/">Home</a>
                                </li>
                                <li className="breadcrumb-item active text-capitalize">
                                    Data Reports
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                {/* /.container-fluid */}
            </section>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">

                                <div
                                    _ngcontent-ng-c219872124=""
                                    className="Super_master_details_section agentledger_block"
                                >
                                    <form
                                        _ngcontent-ng-c219872124=""
                                        noValidate=""
                                        className="card-header bg-gradient-purple text-black border-none p-1 g-lg-3 g-2  ng-pristine ng-valid ng-touched"
                                    >
                                        <div className="row align-items-end">
                                            <div
                                                _ngcontent-ng-c219872124=""
                                                className="col-6 col-md-4 col-lg-3"
                                            >
                                                <div
                                                    _ngcontent-ng-c219872124=""
                                                    className="input_block position-relative text-black"
                                                >
                                                    <label className="text-white text-white mb-0 mt-2" _ngcontent-ng-c219872124="">User Type</label>

                                                    <ReactSelect
                                                        className="text-black"
                                                        options={[
                                                            {
                                                                label: "Client",
                                                                value: "CLIENT",
                                                            },
                                                            {
                                                                label: "Master",
                                                                value: "MASTER",
                                                            },
                                                            {
                                                                label: "Admin",
                                                                value: "ADMIN",
                                                            },
                                                            {
                                                                label: "Sub Admin",
                                                                value: "SUB_ADMIN",
                                                            },
                                                            {
                                                                label: "Agent",
                                                                value: "AGENT",
                                                            },
                                                        ]}
                                                        onChange={(e) => {
                                                            setUserType(e.value);
                                                            setPayload({
                                                                ...payload,
                                                                userType: e.value,
                                                            });
                                                        }}
                                                    />
                                                    {/**/}
                                                </div>
                                            </div>
                                            <div
                                                _ngcontent-ng-c219872124=""
                                                className="col-6 col-md-4 col-lg-3"
                                            >
                                                <div
                                                    _ngcontent-ng-c219872124=""
                                                    className="input_block position-relative"
                                                >
                                                    <label className="text-white text-white mb-0 mt-2" _ngcontent-ng-c219872124="">User</label>
                                                    <ReactSelect
                                                        options={users.map((user) => ({
                                                            label: user.userName + " (" + user.name + ")",
                                                            value: user.userId,
                                                        }))}
                                                        onChange={(e) => {
                                                            setSelectedUserName(e.value);
                                                            setPayload({
                                                                ...payload,
                                                                toFetchFor: e.value,
                                                            });
                                                        }}
                                                    />
                                                    {/**/}
                                                </div>
                                            </div>
                                            <div
                                                _ngcontent-ng-c219872124=""
                                                className="col-6 col-md-4 col-lg-3"
                                            >
                                                <div _ngcontent-ng-c219872124="" className="input_block">
                                                    <label className="text-white text-white mb-0 mt-2" _ngcontent-ng-c219872124="" htmlFor="type">
                                                        Report Type{" "}
                                                    </label>
                                                    <select
                                                        onChange={(e) => {
                                                            setPayload({
                                                                ...payload,
                                                                dataReportType: e.target.value,
                                                            });
                                                        }}
                                                        _ngcontent-ng-c219872124=""
                                                        formcontrolname="reportType"
                                                        className="form-control form-select ng-pristine ng-valid ng-touched"
                                                    >
                                                        <option _ngcontent-ng-c219872124="" value="">
                                                            Select Type
                                                        </option>
                                                        {REPORT_ENUM.map((item) => (
                                                            <option _ngcontent-ng-c219872124="" value={item}>
                                                                {item}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div
                                                _ngcontent-ng-c219872124=""
                                                className="col-6 col-md-4 col-lg-3"
                                            >
                                                <div _ngcontent-ng-c219872124="" className="input_block">
                                                    <label className="text-white text-white mb-0 mt-2" _ngcontent-ng-c219872124="" htmlFor="type">
                                                        Date From
                                                    </label>
                                                    <input
                                                        _ngcontent-ng-c219872124=""
                                                        type="date"
                                                        value={moment(payload.startTime).format("YYYY-MM-DD")}
                                                        onChange={(e) =>
                                                            setPayload({
                                                                ...payload,
                                                                startTime: moment(e.target.value).toISOString(),
                                                            })
                                                        }
                                                        formcontrolname="FromDate"
                                                        className="form-control ng-untouched ng-pristine ng-valid"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                _ngcontent-ng-c219872124=""
                                                className="col-6 col-md-4 col-lg-3"
                                            >
                                                <div _ngcontent-ng-c219872124="" className="input_block">
                                                    <label className="text-white text-white mb-0 mt-2" _ngcontent-ng-c219872124="" htmlFor="type">
                                                        Date To
                                                    </label>
                                                    <input
                                                        _ngcontent-ng-c219872124=""
                                                        type="date"
                                                        value={moment(payload.endTime).format("YYYY-MM-DD")}
                                                        onChange={(e) =>
                                                            setPayload({
                                                                ...payload,
                                                                endTime: moment(e.target.value).toISOString(),
                                                            })
                                                        }
                                                        formcontrolname="EndDate"
                                                        className="form-control ng-untouched ng-pristine ng-valid"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                _ngcontent-ng-c219872124=""
                                                className="col-6 col-md-6 col-lg-3"
                                            >
                                                <div _ngcontent-ng-c219872124="" className="input_block">
                                                    <button
                                                        onClick={() => { getUserActivity(); getAccountStatement(); }}
                                                        _ngcontent-ng-c219872124=""
                                                        type="button"
                                                        className="btn btn-primary"
                                                        disabled=""
                                                    >
                                                        Show Reports
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div _ngcontent-ng-c219872124="" className="card-body custom_table">
                                    <div _ngcontent-ng-c219872124="" className="table-responsive ">
                                        <table className="table table-bordered table-striped no-footer dtr-inline">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>USER ID</th>
                                                    <th>USERNAME</th>
                                                    <th>REPORT TYPE</th>
                                                    <th>LIMIT</th>
                                                    <th>OLD DATA</th>
                                                    <th>NEW DATA</th>
                                                    {/* <th>CHANGED BY</th> */}
                                                    <th>CHANGED BY NAME</th>
                                                    <th>CHANGED AT</th>
                                                    <th>IP ADDRESS</th>
                                                </tr>
                                            </thead>

                                            <tbody className="bg-light">

                                                {data?.length > 0 &&
                                                    data.map((item) => (
                                                        <tr key={item.id}>
                                                            <td>{item.id}</td>
                                                            <td>{item.userId}</td>
                                                            <td>{item.userName}</td>
                                                            <td>{item.dataReportType}</td>
                                                            <td style={{ color: Number(item?.newData) > Number(item?.oldData) ? 'green ' : 'red' }}>
                                                                {(
                                                                    Number(item?.newData || 0) - Math.abs(Number(item?.oldData || 0))
                                                                ).toFixed(2)}{" "}
                                                                {Number(item?.newData) > Number(item?.oldData)
                                                                    ? "Limit Deposit"
                                                                    : "Limit Withdraw"}
                                                            </td>
                                                            <td>{Number(item.oldData)?.toFixed(2)}</td>
                                                            <td>{Number(item.newData)?.toFixed(2)}</td>
                                                            {/* <td>{item.changedBy}</td> */}
                                                            <td>{item.changedByName}</td>
                                                            <td>{moment(item.changedAt + "Z").format("YYYY-MM-DD HH:mm:ss")}</td>
                                                            <td>{item.ipAddress}</td>

                                                        </tr>
                                                    ))}
                                                {opningData?.length > 0 &&
                                                    opningData.map((item) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>{item?.description}</td>
                                                            <td><span style={{ color: "green" }}>{item?.credit || 0} Limit Deposit</span></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>{moment(item.createdAt + "Z").format("YYYY-MM-DD HH:mm:ss")}</td>
                                                            <td></td>

                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}
